module.exports = __webpack_public_path__ + "27f5e4611d8447fca854154ddfeb0a0c.png";